import React from 'react';
import { connect } from 'react-redux';
import DisplayRelative from '../DisplayRelative/DisplayRelative';
import FooterCollapseView from '../FooterCollapseView/FooterCollapseView';

const DisplayTitleValue = ({ nameProduct, detail }) => {
  const arrayDetail = detail[0].listChildCliDetail ? detail[0].listChildCliDetail : detail;
  const detailsType = detail[0].detailType; // Ensure detailsType is defined

  return (
    <div className='wrapper-display-title-value'>
      <div className={`opening-arrow`}>
          {nameProduct != "ENERGY" && (
            <div className='title-opening-arrow'>
              <div className='package-contents'>תכולת חבילה</div>
              <div className='amount-of-uses'>כמות שימושים</div>
            </div>
          )}
        {arrayDetail?.map((item, i) => (
          <div key={`${i}`} className={`info-opening-arrow ${item.isRelative ? 'relative' : ''}`}>
            <div className='info'>{item?.title}</div>
            {item.isRelative ? (
              <DisplayRelative detail={item} nameProduct={nameProduct} />
            ) : nameProduct === "ENERGY" ? (
              <>
                ₪{item?.amountData?.amount}.{item?.amountData?.amountAgorot}
                {item?.amountData?.isAmountMinus && <div className='price-range'>-</div>}
              </>
            ) : (
              <div className='number'>{item?.colomn3 ? item?.colomn3 : item?.colomn2 ? item?.colomn2 : '0'}</div>
            )}
          </div>
        ))}
        {nameProduct === "ENERGY" && <FooterCollapseView nameProduct={nameProduct} />}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    // Add any props needed from state here
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DisplayTitleValue);
